module.exports = __webpack_public_path__ + "754d72b1e1a34139e26b83854fc990d1.jpg";